var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ezqxJ0pabKy1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.386971,303.577551C232.696547,245.998302,290.85493,142.915117,304.3152,-1.212956c3.651243-39.096288-108.579061.636475-108.366678,4.788593c4.84998,94.81758-49.062988,224.437196-102.83161,299.202232",
    transform: "matrix(1 0 0 1.029382-33.4293-8.239714)",
    fill: "#cf3341",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.879117,301.527042c37.87436-78.653116,85.476651-199.755577,78.265833-299.902022C220.802345,-3.133196,197.844902,2.24922,150,0c14.681422,89.394897-17.705833,222.969563-78.490274,301.028436",
    transform: "matrix(1 0 0 1.029725-18.178982-6.232341)",
    fill: "#ffbf40",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.862071,291.249068c34.531269-69.514557,54.929484-169.266524,53.898992-265.627794-19.583979.027369-43.829087.027369-67.488094.027369c12.888636,72.290598.771761,190.555928-20.173319,265.600425",
    transform: "matrix(1.094465 0 0 1.168891-23.456626-36.180823)",
    fill: "#0825b6",
    stroke: "#3f5787",
    strokeWidth: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c120bbace9f6f9bfb3d628f62cfb6945.svg";
export { ForwardRef as ReactComponent };